// src/components/pages/sports/Partials/AboutSports.jsx
import React, { useEffect, useState } from "react";
import Slider from 'react-slick';

const AboutSports = ({ aboutSection }) => {
  const [showMore, setShowMore] = useState(false);

  if (!aboutSection) return <></>;

  const sliderSettings = {
    dots: false,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const toggleReadMore = () => setShowMore(prev => !prev);

  return (
    <>
      {/* Desktop */}
      <section className="sports pb_80 d-none d-md-block">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{aboutSection.title}</h2>
          </div>

          <div className="row mb-5 pb-5 d-flex justify-content-center align-items-center">
            {/* First row: First paragraph + First image */}
            <div className="col-md-7">
              {aboutSection.about_content?.[0] && (
                <p className="mb-3">{aboutSection.about_content[0]}</p>
              )}
            </div>
            <div className="col-md-4 text-center">
              {aboutSection.about_image?.[0] && (
                <img
                  src={`${process.env.REACT_APP_API_URL}/public${aboutSection.about_image[0]}`}
                  alt="Athletic competition"
                  className="img-sports img-fluid"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
            </div>
          </div>

          {/* Second row: Only show if we have second paragraph or second image */}
          {(aboutSection.about_content?.[1] || aboutSection.about_image?.[1]) && (
            <div className="row mb-5 d-flex justify-content-center align-items-center">
              <div className="col-md-4 text-center">
                {aboutSection.about_image?.[1] && (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public${aboutSection.about_image[1]}`}
                    alt="Athletic competition"
                    className="img-sports img-fluid"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
              </div>
              <div className="col-md-7">
                {aboutSection.about_content?.[1] && (
                  <p className="mb-3">{aboutSection.about_content[1]}</p>
                )}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Mobile */}
      <section className="sports p d-block d-md-none">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{aboutSection.title}</h2>
          </div>
    <Slider {...sliderSettings}>
            {aboutSection.about_image?.map((img, index) => (
              img && (
                <div key={index}>
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public${img}`}
                    alt={`Athletic competition ${index + 1}`}
                    className="img-sports w-100 mb-2"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )
            ))}
          </Slider>
          <div>
            {/* ALWAYS show first paragraph */}
            {aboutSection.about_content?.[0] && (
              <p className="mb-3">{aboutSection.about_content[0]}</p>
            )}
            
            {/* Show second paragraph only if "Read More" is clicked */}
            {showMore && aboutSection.about_content?.[1] && (
              <p className="mb-3">{aboutSection.about_content[1]}</p>
            )}
            
            {/* Only show the button if there's more content to show */}
            {aboutSection.about_content?.length > 1 && (
              <button onClick={toggleReadMore} className="readmoreall mb-3">
                {showMore 
                  ? `${aboutSection.readless_btn || 'Read Less'}` 
                  : `${aboutSection.readmore_btn || 'Read More'}`
                }
              </button>
            )}
          </div>

      
        </div>
      </section>
    </>
  );
};

export default AboutSports;